import React from 'react'
import { Input, Select } from 'loyal-react'
import PropTypes from 'prop-types'

const FormFuelCredit = ({
  errorField,
  isLoadingChangeAccountType,
  packages,
  handlerChangePackage,
  packageSelected,
  currencyConfiguration,
  handlerFormatValue
}) => (
  <div className='row'>
    <div className='col-12 px-0'>
      <div className='row'>
        <Select
          id='FuelCredit'
          label='Quantos créditos você deseja?'
          className='col-12 col-md-6'
          displayValue='description'
          selectedValue='id'
          options={packages || []}
          onChange={handlerChangePackage}
          data-error={'Nenhum crédito selecionado'}
          valid={errorField}
          value={packageSelected.id ? packageSelected : null}
        />
        <Input
          id='voce_vai_obter'
          label='Valor em reales'
          className='col-12 col-md-6'
          value={`${handlerFormatValue(
            packageSelected.pointsQuantity || 0,
            currencyConfiguration.decimalPlaces
          )} ${currencyConfiguration.pointsName}`}
        />
      </div>
      <br />
      <div
        className={`btn-loading mr-auto ml-auto ${
          isLoadingChangeAccountType ? 'd-block' : 'd-none'
        }`}
      >
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
)

FormFuelCredit.propTypes = {
  errorField: PropTypes.bool,
  isLoadingChangeAccountType: PropTypes.bool,
  packages: PropTypes.array,
  handlerChangePackage: PropTypes.func,
  packageSelected: PropTypes.object,
  currencyConfiguration: PropTypes.object,
  handlerFormatValue: PropTypes.func
}

export default FormFuelCredit



// WEBPACK FOOTER //
// ./src/features/FuelCredit/FormFuelCredit.js